import { Center } from '@vimeo/bokeh';
import { ErrorView } from '@vimeo/clip-ui/views/ErrorView';
import { UnauthorizedError } from '@vimeo/core/libs/errors';

export const ErrorPage = () => (
  <Center h="100vh" w="100%" bgColor="surface">
    <ErrorView error={new UnauthorizedError()} />
  </Center>
);
